<template>
    <div>
        <div>
            <div class="field has-addons mb-2" v-if="step < 2">
                <div class="control">
                    <input class="input" type="text" :placeholder="translate('page.save_competitors.find_country')" v-model="searchQuery" />
                </div>
                <div class="control">
                    <a class="button" @click="searchQuery = ''">
                        <span class="icon">
                            <i class="fa fa-times" />
                        </span>
                    </a>
                </div>
            </div>
            <div class="field">
                <div class="buttons" v-if="step === 0 && searchQuery.length === 0">
                    <button class="button" @click="chooseContinent('Asia')">{{ translate("country.asia") }}</button>
                    <button class="button" @click="chooseContinent('Africa')">{{ translate("country.africa") }}</button>
                    <button class="button" @click="chooseContinent('North America')">
                        {{ translate("country.north_america") }}
                    </button>
                    <button class="button" @click="chooseContinent('South America')">
                        {{ translate("country.south_america") }}
                    </button>
                    <button class="button" @click="chooseContinent('Europe')">{{ translate("country.europe") }}</button>
                    <button class="button" @click="chooseContinent('Oceania')">
                        {{ translate("country.oceania") }}
                    </button>
                </div>
            </div>
        </div>

        <div v-if="step === 1 || (searchQuery.length > 0 && step !== 2)">
            <div class="buttons">
                <button v-if="searchQuery.length === 0" class="button is-danger" @click="goBack">
                    <span class="icon">
                        <i class="fa fa-undo" />
                    </span>
                    <span>
                        {{ translate("common.go_back") }}
                    </span>
                </button>
                <button class="button" v-for="country in countries" @click="chooseCountry(country)" :key="country.code">
                    <Country :country-code="country.code" />
                </button>
            </div>
        </div>
        <div v-if="step === 2">
            <div class="buttons">
                <div class="button">
                    <Country :country-code="selectedCountry.code" />
                </div>
                <button class="button is-danger is-outlined" @click="goBack">
                    <span class="icon">
                        <i class="fa fa-times" />
                    </span>
                    <span>
                        {{ translate("common.change") }}
                    </span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import { nextTick } from "vue";
    import countries from "../Common/countries.json";
    import objectMatcher from "../Common/objectMatcher";
    import Country from "../Common/Country";
    import translatorMixin from "../Common/translatorMixin";

    export default {
        name: "country-selector",
        components: { Country },
        mixins: [translatorMixin],
        emits: ["countrySelected"],
        data() {
            return {
                selectedCountry: {},
                searchQuery: "",
                step: 0,
                countries: [],
                translatedCountriesList: [],
            };
        },
        watch: {
            searchQuery() {
                if (this.searchQuery.length > 0) {
                    this.countries = this.filterByName();
                    return;
                }
                if (this.searchQuery.length === 0) {
                    this.countries = [];
                    this.step = 0;
                }
            },
        },
        mounted() {
            this.translatedCountriesList = countries.map(countryData => {
                return {
                    code: countryData.code,
                    name: this.translate("country." + countryData.code.toUpperCase()),
                    continent: countryData.continent,
                };
            });
        },
        methods: {
            init(initCountryCode) {
                this.step = 0;
                this.searchQuery = "";
                this.countries = [];
                this.selectedCountry = {};

                if (initCountryCode) {
                    this.chooseCountry(this.findCountryByCode(initCountryCode));
                }
            },
            chooseCountry(country) {
                if (country && country.code) {
                    this.searchQuery = "";

                    nextTick(() => {
                        this.selectedCountry = country;
                        this.step = 2;
                        this.$emit("countrySelected", country.code);
                    });
                }
            },
            chooseContinent(continentName) {
                this.countries = this.filterByContinent(continentName);
                this.step = 1;
            },
            filterByName() {
                return this.translatedCountriesList.filter(country => {
                    return objectMatcher.matchString(this.searchQuery, country.name);
                });
            },
            filterByContinent(continentName) {
                return this.translatedCountriesList.filter(country => {
                    return country.continent === continentName;
                });
            },
            findCountryByCode(code) {
                return this.translatedCountriesList.find(country => {
                    return country.code === code;
                });
            },
            goBack() {
                if (this.step > 0) {
                    this.step--;
                }

                if (this.step === 1) {
                    this.chooseContinent(this.selectedCountry.continent);
                }
            },
        },
    };
</script>

<style scoped></style>
